import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';

import { Card, CardHeader } from '../components/Card';
import { BucketCard } from '../components/BucketList';
import { Button } from '../components/Control.js';

import { SVGHome, SVGMoneyNote } from '../components/SVG';

export default function Buckets({fuelData, groceriesData}) {
    return (
        <div className='flex flex-col relative px-3 gap-3 body-spacing'>
            <Card>
                <CardHeader heading='Fuel' emoji="⛽" to={"/buckets"} />
                <BucketCard valueTotal={fuelData.valueTotal} valueLeft={fuelData.valueLeft} percentage={fuelData.percentage} colour={fuelData.colour} />
            </Card>
            <Card>
                <CardHeader heading='Groceries' emoji="🥦" to={"/buckets"} />
                <BucketCard valueTotal={groceriesData.valueTotal} valueLeft={groceriesData.valueLeft} percentage={groceriesData.percentage} colour={groceriesData.colour} />
            </Card>
            <div className='flex flex-col items-center gap-2'>
                <Button type='primary' label='Add a transaction' />
                <Button type='secondary' label='Add a transaction' />
            </div>
            <div className='flex flex-col items-center gap-2 mt-5'>
                <Button type='primary' label='Add a transaction' loading='true'  />
                <Button type='secondary' label='Add a transaction' loading='true'  />
            </div>
            <div className='flex flex-col items-center gap-2 mt-5'>
                <Button type='primary' label='Add a transaction' disabled='true'  />
                <Button type='secondary' label='Add a transaction' disabled='true'  />
            </div>
        </div>
    );
}